import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '@api';
import type { RootState } from '@store';
import { SERVER_ERROR } from '@config/constants';
import { cartSelector } from '@store/slices/cart/selectors';
import {
  RemoveCartItemResponse, REMOVE_CART_ITEM_MUTATION, RemoveCartItemInput,
  GetCartDiscountsResponse, GET_CART_DISCOUNTS_QUERY, SET_PROMO_CODE_TO_CART_MUTATION, GetCartResponse, GET_CART_QUERY,
} from '@requests/cart';

type RemoveCartItemResult = GetCartResponse & GetCartDiscountsResponse;

export const removeCartItem = createAsyncThunk<RemoveCartItemResult, string>(
  'cart/removeCartItem',
  async (removedProductId, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const { cartId } = cartSelector(state);
      const input: RemoveCartItemInput = { orderUid: cartId, removableItemUid: removedProductId };

      await client.request<RemoveCartItemResponse>(REMOVE_CART_ITEM_MUTATION, input);

      const [cartData, cartDiscounts] = await Promise.all([
        client.request<GetCartResponse>(GET_CART_QUERY, { uid: cartId }),
        client.request<GetCartDiscountsResponse>(GET_CART_DISCOUNTS_QUERY, { uid: cartId }),
      ]);

      const couponId = cartData.wGetCart.cart.corPromoCodes?.[0]?.prmId;
      const couponDiscount = cartDiscounts.wGetCartDiscounts.discounts.couponTotalDiscount;

      if (couponId && !couponDiscount) {
        const removeVariables = { orderUid: cartId, promoCodes: [] };
        await client.request(SET_PROMO_CODE_TO_CART_MUTATION, removeVariables);
        cartData.wGetCart.cart.corPromoCodes = [];
      }

      return { ...cartData, ...cartDiscounts };
    } catch (error) {
      return rejectWithValue(SERVER_ERROR);
    }
  },
);
